import { useState } from 'react';

import { Grid, Paper, Typography } from '@mui/material';

import { grey } from '@mui/material/colors';
import InstrumentConfiguration from 'features/instrumentConfiguration/InstrumentConfiguration';

import { useAnalyzers } from 'features/analyzers/api/getAnalyzers';
import { useAnalyzer } from 'features/analyzers/api/getAnalyzer';
import AnalyzerSettings from 'features/timeWarning/AnalyzerSettings';
import { InstrumentType } from './types';

const InstrumentsPage = () => {
  const { data: analyzers } = useAnalyzers({});
  const [selectedInstrumentId, setSelectedInstrumentId] = useState<number>(-1);
  const [selectedInstrumentType, setSelectedInstrumentType] =
    useState<InstrumentType>(InstrumentType.ANALYZER);

  const { data: analyzer } = useAnalyzer({ analyzerId: selectedInstrumentId });

  return (
    <Grid container spacing={1}>
      <Grid
        item
        container
        xs={8}
        style={{ paddingRight: '.5rem', minWidth: 540 }}
      >
        <InstrumentConfiguration
          selectedInstrumentType={selectedInstrumentType}
          setSelectedInstrumentType={setSelectedInstrumentType}
          selectedInstrumentId={selectedInstrumentId}
          setSelectedInstrumentId={setSelectedInstrumentId}
        />
      </Grid>
      <Grid
        container
        item
        xs
        component={Paper}
        style={{ margin: 0, marginTop: '66px' }}
        spacing={2}
      >
        {analyzers &&
        analyzers.length > 0 &&
        selectedInstrumentId !== -1 &&
        selectedInstrumentType === InstrumentType.ANALYZER ? (
          <Grid item container>
            <AnalyzerSettings analyzer={analyzer} />
          </Grid>
        ) : (
          <Typography sx={{ p: '2rem' }} color={grey[500]}>
            Select an analyzer to view settings.
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};

export default InstrumentsPage;
